/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OverviewUserResource } from './overviewUserResource';
import { OverviewItemResource } from './overviewItemResource';
import { OverviewDepositResource } from './overviewDepositResource';
import { OverviewAutoResource } from './overviewAutoResource';


export interface OverviewResource { 
    currency: OverviewResource.CurrencyEnum;
    currentUser: OverviewUserResource;
    brokerUsers: Array<OverviewUserResource>;
    overviewItems: Array<OverviewItemResource>;
    totalReward: number;
    agree: boolean;
    info: string;
    auto: OverviewAutoResource;
    deposits: Array<OverviewDepositResource>;
}
export namespace OverviewResource {
    export type CurrencyEnum = 'Kč' | 'Eur';
    export const CurrencyEnum = {
        K: 'Kč' as CurrencyEnum,
        Eur: 'Eur' as CurrencyEnum
    };
}


